export enum ContentCreatorProperties {
  Name = "name",
  Description = "description",
  ProfileImage = "profileImage",
  Owner = "owner",
  Id = "id",
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
  Version = "version",
  ContentHouseId = "contentHouseId"
}
export enum ContentCreatorMetaProperties {}
